<template>
  <div>
    <top-bar :heading="'Edit ' + user.name_full" v-if="id" :buttons="buttons"></top-bar>
    <top-bar heading="Create User" v-if="!id"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card header="User Information">
        <b-card-body class="p-3">
          <div class="row p-3">
            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="name_first">First Name</label>
              <input :class="{'form-control': true, 'is-invalid': errors.has('name_first')}"
                     v-validate="'required'"
                     data-vv-delay="500"
                     data-vv-as="First Name"
                     data-vv-name="name_first"
                     type="text"
                     placeholder="First Name"
                     name="name_first"
                     id="name_first"
                     v-model="user.name_first"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('name_first')">{{ errors.first('name_first') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="name_last">Last Name</label>
              <input :class="{'form-control': true, 'is-invalid': errors.has('name_last')}"
                     v-validate="'required'"
                     data-vv-delay="500"
                     data-vv-as="Last Name"
                     data-vv-name="name_last"
                     type="text"
                     placeholder="Last Name"
                     name="name_last"
                     id="name_last"
                     v-model="user.name_last"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('name_last')">{{ errors.first('name_last') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="email">Email</label>
              <div class="input-group">
                <input :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                       v-validate="'required|email'"
                       data-vv-delay="500"
                       data-vv-as="Email"
                       data-vv-name="email"
                       type="text"
                       placeholder="Email"
                       name="email"
                       id="email"
                       v-model="user.email"/>
                <div class="input-group-append" v-show="emailLoading">
                  <span class="input-group-text">
                    <font-awesome-icon icon="cog" spin></font-awesome-icon>
                  </span>
                </div>
              </div>
              <div class="invalid-tooltip d-block" v-if="errors.has('email')">{{ errors.first('email') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="address_street">Street Name</label>
              <input :class="{'form-control': true, 'is-invalid': errors.has('address_street')}"
                     v-validate="'required'"
                     data-vv-delay="500"
                     data-vv-as="Street Name"
                     data-vv-name="address_street"
                     type="text"
                     placeholder="Street Name"
                     name="address_street"
                     id="address_street"
                     :readonly="$auth.check('student')"
                     v-model="user.address_street"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('address_street')">{{ errors.first('address_street') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="address_town">City/Town</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('address_town')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="City/Town"
                      data-vv-name="address_town"
                      type="text"
                      placeholder="City/Town"
                      name="address_town"
                      id="address_town"
                      :readonly="$auth.check('student')"
                      v-model="user.address_town"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('address_town')">{{ errors.first('address_town') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="address_state">State</label>
              <select :class="{'form-control': true, 'is-invalid': errors.has('address_state')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="State"
                      data-vv-name="address_state"
                      name="address_state"
                      id="address_state"
                      :readonly="$auth.check('student')"
                      v-model="user.address_state">
                <option label="ACT" :value="1">ACT</option>
                <option label="NSW" :value="2" selected="selected">NSW</option>
                <option label="NT" :value="3">NT</option>
                <option label="QLD" :value="4">QLD</option>
                <option label="SA" :value="5">SA</option>
                <option label="TAS" :value="6">TAS</option>
                <option label="VIC" :value="7">VIC</option>
                <option label="WA" :value="8">WA</option>
              </select>
              <div class="invalid-tooltip d-block" v-if="errors.has('address_state')">{{ errors.first('address_state') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="address_postcode">Postcode</label>
              <input :class="{'form-control': true, 'is-invalid': errors.has('address_postcode')}"
                     v-validate="'required|numeric'"
                     data-vv-delay="500"
                     data-vv-as="Postcode"
                     data-vv-name="address_postcode"
                     type="text"
                     placeholder="Postcode"
                     name="address_postcode"
                     id="address_postcode"
                     :readonly="$auth.check('student')"
                     v-model="user.address_postcode"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('address_postcode')">{{ errors.first('address_postcode') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="phone_mobile">Mobile Phone</label>
              <input
                      :class="{'form-control': true, 'is-invalid': errors.has('phone_mobile')}"
                      v-validate="'required|numeric'"
                      data-vv-delay="500"
                      data-vv-as="Mobile Phone"
                      data-vv-name="phone_mobile"
                      type="text"
                      placeholder="Mobile Phone"
                      name="phone_mobile"
                      id="phone_mobile"
                      v-model="user.phone_mobile"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('phone_mobile')">{{ errors.first('phone_mobile') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="dob">Date Of Birth</label>
              <flat-pickr
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Date Of Birth"
                      data-vv-name="dob"
                      placeholder="Date Of Birth"
                      name="dob"
                      id="dob"
                      class="form-control"
                      :config="$dateOptions"
                      v-model="user.dob">
              </flat-pickr>
              <div class="invalid-tooltip d-block" v-if="errors.has('dob')">{{ errors.first('dob') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="gender">Gender</label>
              <select :class="{'form-control': true, 'is-invalid': errors.has('gender')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Gender"
                      data-vv-name="gender"
                      name="gender"
                      id="gender"
                      v-model="user.gender">
                <option :value="1">Male</option>
                <option :value="2">Female</option>
                <option :value="3">Other</option>
              </select>
              <div class="invalid-tooltip d-block" v-if="errors.has('gender')">{{ errors.first('gender') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="notification_level">Notification Level</label>
              <select
                      :class="{'form-control': true, 'is-invalid': errors.has('notification_level')}"
                      v-validate="'required'"
                      data-vv-delay="500"
                      data-vv-as="Notification Level"
                      data-vv-name="notification_level"
                      name="notification_level"
                      id="notification_level"
                      v-model="user.notification_level">
                <option :value="1">Send Email Only</option>
                <option :value="2">Send SMS Only</option>
                <option :value="3">Send SMS and Email</option>
              </select>
              <div class="invalid-tooltip d-block" v-if="errors.has('notification_level')">{{ errors.first('notification_level') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1">
              <label class="control-label visible-ie8 visible-ie9" for="profile_picture">Profile Picture</label>
              <b-form-file v-model="user.file" accept="image/*" id="profile_picture"></b-form-file>
              <div class="invalid-tooltip d-block" v-if="errors.has('notification_level')">{{ errors.first('notification_level') }}</div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 p-1" v-if="id">
              <label class="control-label visible-ie8 visible-ie9" for="password">Password</label>
              <input :class="{'form-control': true, 'is-invalid': errors.has('password')}"
                     data-vv-delay="500"
                     data-vv-as="Password"
                     data-vv-name="password"
                     type="password"
                     placeholder="Password"
                     name="password"
                     id="password"
                     ref="password"
                     v-model="user.password"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('password')">{{ errors.first('password') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1" v-if="id">
              <label class="control-label visible-ie8 visible-ie9" for="password_confirmation">Password Confirmation</label>
              <input :class="{'form-control': true, 'is-invalid': errors.has('password_confirmation')}"
                     v-validate="'confirmed:password'"
                     data-vv-delay="500"
                     data-vv-as="Password"
                     data-vv-name="password_confirmation"
                     type="password"
                     placeholder="Password Confirmation"
                     name="password_confirmation"
                     id="password_confirmation"
                     v-model="user.password_confirmation"/>
              <div class="invalid-tooltip d-block" v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1" v-if="id">
              <template v-if="$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin'])">
                <label class="control-label visible-ie8 visible-ie9" for="enabled">Status</label>
                <br/>
                <b-form-radio-group buttons
                                    button-variant="outline-primary"
                                    block
                                    class="w-100"
                                    v-model="user.enabled"
                                    :options="[{text: 'Enabled', value: 1},{text: 'Disabled', value: 0}]"
                                    v-validate="'required'"
                                    data-vv-delay="500"
                                    data-vv-as="Enabled"
                                    data-vv-name="enabled"
                                    placeholder="enabled"
                                    name="enabled"
                                    id="enabled"/>
                <div class="invalid-tooltip d-block" v-if="errors.has('enabled')">{{ errors.first('enabled') }}</div>
              </template>
            </div>
            <div class="col-12 mb-3 mt-3">
              <loading-button :loading="loading" block variant="orange" @submit="onSubmit" :disabled="errors.any()"></loading-button>
            </div>
            <div class="col-12 mb-3 mt-3" v-if="user.id === $auth.user().id">
              <social-connection-buttons></social-connection-buttons>
            </div>
          </div>
        </b-card-body>
      </b-card>
      <b-card header="Role" v-if="$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin']) && parseInt(id) !== parseInt($auth.user().id)">
        <b-card-body class="p-3">
          <div class="col-12 d-block d-lg-none role-buttons">
            <!--<label class="control-label visible-ie8 visible-ie9" for="role">Role</label>-->
            <b-form-checkbox-group buttons
                                   button-variant="outline-success"
                                   block
                                   multiple
                                   v-model="user.roles"
                                   :options="roles"
                                   v-validate="'required'"
                                   data-vv-delay="500"
                                   data-vv-as="Role"
                                   data-vv-name="role"
                                   type="text"
                                   placeholder="Role"
                                   name="role"
                                   stacked
                                   id="role"/>
            <div class="invalid-tooltip d-block" v-if="errors.has('role')">{{ errors.first('role') }}</div>
          </div>
          <div class="col-12 d-none d-lg-block role-buttons">
            <!--<label class="control-label visible-ie8 visible-ie9" for="role">Role</label>-->
            <b-form-checkbox-group buttons
                                   button-variant="outline-success"
                                   block
                                   v-model="user.roles"
                                   :options="roles"
                                   v-validate="'required'"
                                   data-vv-delay="500"
                                   data-vv-as="Role"
                                   data-vv-name="role"
                                   type="text"
                                   placeholder="Role"
                                   name="role"
                                   id="role"/>
            <div class="invalid-tooltip d-block" v-if="errors.has('role')">{{ errors.first('role') }}</div>
          </div>
        </b-card-body>
      </b-card>
      <b-card header="RTO" v-if="$auth.check('admin', 'super_admin') && !is_admin">
        <b-card-body class="row p-2 pb-3">
          <div class="col-12 col-lg-6">
            <label class="control-label visible-ie8 visible-ie9" for="rto">RTO</label>
            <select :class="{'form-control': true, 'is-invalid': errors.has('rto')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="RTO"
                    data-vv-name="rto"
                    name="rto"
                    id="rto"
                    v-model="user.rto_id">
              <option :value="0">---</option>
              <option v-for="rto in rtos" :key="rto.id" :value="rto.id">{{ rto.name }}</option>
            </select>
            <div class="invalid-tooltip d-block" v-if="errors.has('rto')">{{ errors.first('rto') }}</div>
          </div>
        </b-card-body>
      </b-card>
      <b-card header="RTO Trainer" v-if="$auth.check(['admin', 'super_admin', 'rto']) && is_student">
        <b-card-body class="row p-2 pb-3 text-center">
          <div class="col-12 col-lg-4">
            <select :class="{'form-control': true, 'is-invalid': errors.has('rto_trainer_id')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="RTO Trainer"
                    data-vv-name="rto_trainer_id"
                    name="rto_trainer_id"
                    id="rto_trainer_id"
                    v-model="user.rto_trainer_id">
              <option :value="0">---</option>
              <option v-for="rto_trainer in rto_trainers" :key="rto_trainer.id" :value="rto_trainer.id">{{ rto_trainer.name_full }}</option>
            </select>
            <div class="invalid-tooltip d-block" v-if="errors.has('rto_trainer_id')">{{ errors.first('rto_trainer_id') }}</div>
          </div>
          <div class="col-12 col-lg-4"><h3>- OR -</h3></div>
          <div class="col-12 col-lg-4">
            <b-button variant="orange" block @click="openRtoTrainer">Create RTO Trainer</b-button>
          </div>
        </b-card-body>
      </b-card>
      <b-card header="Workplace Supervisor" v-if="$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer']) && is_student">
        <b-card-body class="row p-2 pb-3 text-center">
          <div class="col-12 col-lg-4">
            <select :class="{'form-control': true, 'is-invalid': errors.has('trainer_id')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="Workplace Supervisor"
                    data-vv-name="trainer_id"
                    name="trainer_id"
                    id="trainer_id"
                    v-model="user.trainer_id">
              <option :value="0">---</option>
              <option v-for="trainer in trainers" :key="trainer.id" :value="trainer.id">{{ trainer.name_full }}</option>
            </select>
            <div class="invalid-tooltip d-block" v-if="errors.has('trainer_id')">{{ errors.first('trainer_id') }}</div>
          </div>
          <div class="col-12 col-lg-4"><h3>- OR -</h3></div>
          <div class="col-12 col-lg-4">
            <b-button variant="orange" block @click="openWorkplaceSupervisor">Create Workplace Supervisor</b-button>
          </div>
        </b-card-body>
      </b-card>
      <b-card header="Employer" v-if="$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer']) && is_student">
        <b-card-body class="row p-2 pb-3 text-center">
          <div class="col-12 col-lg-4">
            <select :class="{'form-control': true, 'is-invalid': errors.has('employer_id')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="Employer"
                    data-vv-name="employer_id"
                    name="employer_id"
                    id="employer_id"
                    v-model="user.employer_id">
              <option :value="0">---</option>
              <option v-for="employer in employers" :key="employer.id" :value="employer.id">{{ employer.name_full }} - {{ employer.name_company }}</option>
            </select>
            <div class="invalid-tooltip d-block" v-if="errors.has('employer_id')">{{ errors.first('employer_id') }}</div>
          </div>
          <div class="col-12 col-lg-4"><h3>- OR -</h3></div>
          <div class="col-12 col-lg-4">
            <b-button variant="orange" block @click="openEmployerDialog">Create Employer</b-button>
          </div>
        </b-card-body>
      </b-card>
      <b-card header="Revision History" v-if="$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer']) && user.id">
        <b-card-body class="row text-center">
          <div class="col">
            <user-revisions :id="user.id"></user-revisions>
          </div>
        </b-card-body>

      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import debounce from 'lodash-es/debounce'
import CheckEmail from '../../mixins/CheckEmail'

import EmployerDialog from '../../components/Users/CreateEmployer'
import CreateWorkplaceSupervisor from '../../components/Users/CreateWorkplaceSupervisor'
import CreateRtoTrainer from '../../components/Users/CreateRtoTrainer'
import SocialConnectionButtons from '../../components/SocialConnectionButtons'
import UserRevisions from '../../components/Users/UserRevisions'

export default {
  name: 'UsersEdit',
  components: { UserRevisions, SocialConnectionButtons },
  data () {
    return {
      loaded: false,
      user: {
        role_id: 6,
        is_student: true,
        name: '',
        enabled: 1,
        roles: []
      },
      form: new FormData(),
      loading: false,
      buttons: [
        //{label: 'Edit User', 'url': '/users/' + this.id },
        { label: 'Training Plan', 'url': '/users/' + this.id + '/training_plan', access: this.$auth.check(['rto', 'rto_trainer', 'admin', 'super_admin']) },
        { label: 'Progression', url: '/users/' + this.id + '/progression' },
        { label: 'Results', url: '/users/' + this.id + '/results' }
      ]
    }
  },
  computed: {
    ...mapState(['trainers', 'rto_trainers', 'employers', 'rtos']),
    roles () {
      return [...this.$store.state.roles].map(row => {
        return { text: row.name, value: row.name, multiple: (row.name === 'Employer' || row.name === 'Workplace Supervisor') }
      })
    },
    is_student () {
      return ['Apprenticeship', 'Green', 'Silver', 'Gold', 'Platinum'].some(val => {
        return this.user.roles.includes(val)
      })
    },
    is_admin () {
      return this.user.roles.includes('admin') || this.user.roles.includes('super_admin') || this.user.roles.includes('Content Curator')
    }
  },
  methods: {
    onSubmit () {
      this.$validator.validate().then(result => {
        if (result) {

          let formData = new FormData()
          formData.append('_method', 'PUT')
          Object.keys(this.user).forEach(key => {
            formData.append(key, this.user[key])
          })

          this.form = formData

          if (this.id) {
            this.updateUser()
          } else {
            this.createUser()
          }
        }
      })
    },
    updateUser () {
      this.loading = true

      this.axios.post('/users/' + this.id, this.form).then(rsp => {
        this.$swal('success', 'User Updated', 'success')
        this.user = rsp.data.data
        if (this.$auth.user().id === this.user.id) {
          this.$auth.fetch()
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$errorOut(err)
      })
    },
    createUser () {
      this.loading = true
      this.axios.post('/users/', this.user).then(rsp => {
        this.$swal('success', 'User Updated', 'success')
        this.$router.push('/users/' + rsp.data.data.id)
      }).catch(err => {
        this.loading = false
        this.$errorOut(err)
      })
    },
    openEmployerDialog () {
      this.$modal.show(EmployerDialog, {}, { width: '75%', resizable: true, adaptive: true, scrollable: true, height: 'auto' })
    },
    openWorkplaceSupervisor () {
      this.$modal.show(CreateWorkplaceSupervisor, {}, { width: '75%', resizable: true, adaptive: true, scrollable: true, height: 'auto' })
    },
    openRtoTrainer () {
      this.$modal.show(CreateRtoTrainer, {}, { width: '75%', resizable: true, adaptive: true, scrollable: true, height: 'auto' })
    }
  },
  watch: {
    'user.roles' (newVal) {
      if ((newVal.includes('Workplace Supervisor') && newVal.includes('Employer')) && newVal.length === 2) {
        //this.user.roles = ['Workplace Supervisor', 'Employer'];
      } else if (newVal.length > 1) {
        newVal.splice(0, newVal.length - 1)
      }

      return newVal
    },
    'user.email': debounce(function (newVal, oldVal) {
      if (oldVal === undefined && this.id || !newVal) {
        return
      }

      this.checkEmail(newVal, this.id)

    }, 2000)
  },
  mounted () {
    if (this.id) {
      this.loaded = false
      this.axios.get('/users/' + this.id).then(rsp => {
        this.user = rsp.data.data
        this.loaded = true
      }).catch(err => this.$errorOut(err))
    } else {
      this.loaded = true
    }
    this.$store.dispatch('LOAD_WORKPLACE_TRAINERS', this)
    this.$store.dispatch('LOAD_EMPLOYERS', this)
    this.$store.dispatch('LOAD_RTO_TRAINERS', this)
    this.$store.dispatch('LOAD_ROLES', this)
    if (this.$auth.check('admin', 'super_admin', 'super_admin')) {
      this.$store.dispatch('LOAD_RTOS', this)
    }
  },
  metaInfo () {
    return {
      title: !this.id ? 'Create User' : 'Edit ' + this.user.name_full
    }
  },
  mixins: [CheckEmail],
  props: ['id']
}
</script>

<style lang="scss">
  .flatpickr-input {
    background-color: white !important;
  }

  .role-buttons {
    .btn-group-toggle, .btn-group {
      width: 100%;
    }

    .btn-group > .btn, .btn-group-vertical > .btn {
      position: relative;
      -webkit-box-flex: 0;
      -ms-flex: 0 1 auto;
      flex: 1 1 auto;
    }
  }
</style>
